import { isDefined, isSameId } from "../../helpers";
import { uid } from "@xbs/lib-state";
export function moveSelectedTasksDown({ store }) {
    const selected = store.getState().selected;
    let $meta;
    if (selected.length > 1) {
        $meta = { batch: uid() };
    }
    store.eachSelected(id => {
        const parent = store.getTask(store.getTask(id).parent);
        !parent?.selected && moveTaskDown(store, id, $meta);
    }, true, true);
}
export function moveSelectedTasksUp({ store }) {
    const selected = store.getState().selected;
    let $meta;
    if (selected.length > 1) {
        $meta = { batch: uid() };
    }
    store.eachSelected(id => {
        const parent = store.getTask(store.getTask(id).parent);
        !parent?.selected && moveTaskUp(store, id, $meta);
    }, true);
}
function moveTaskDown(store, id, $meta) {
    const { treeTasks, filter, taskShape } = store.getState();
    const hideCompleted = taskShape?.completed?.taskHide;
    const filtered = isDefined(filter?.match);
    const targetId = store.getNearId({
        id,
        dir: "next",
        flat: true,
        filtered,
        hideCompleted,
    });
    const target = store.getTask(targetId);
    const task = store.getTask(id);
    if (isSameId(treeTasks.at(-1).id, id) ||
        !isSameId(target?.parent, task?.parent))
        return;
    store.in.exec("move-task", {
        id,
        parent: task?.parent,
        targetId,
        $meta,
    });
}
function moveTaskUp(store, id, $meta) {
    const { treeTasks, filter, taskShape } = store.getState();
    const hideCompleted = taskShape?.completed?.taskHide;
    const filtered = isDefined(filter?.match);
    const targetId = store.getNearId({
        id,
        dir: "prev",
        flat: true,
        filtered,
        hideCompleted,
    });
    const target = store.getTask(targetId);
    const task = store.getTask(id);
    if (isSameId(treeTasks[0].id, id) ||
        !isSameId(target?.parent, task?.parent))
        return;
    store.in.exec("move-task", {
        id,
        targetId,
        parent: task?.parent,
        reverse: true,
        $meta,
    });
}
//# sourceMappingURL=move.js.map